import axios, { AxiosResponse } from 'axios';

interface GistDto {
  files: {
    [filename: string]: {
      content: string;
    };
  };
}
export const getGistContent = async (url: string): Promise<string> => {
  try {
    const response: AxiosResponse<GistDto> = await axios.get(url);
    return response.data.files[Object.keys(response.data.files)[0]].content;
  } catch (e) {
    console.error(`Failed to fetch gist content at url ${url}: ${e.message}`);
    return '';
  }
};
